import { render, staticRenderFns } from "./custom-row.vue?vue&type=template&id=df3c8938&"
import script from "./custom-row.vue?vue&type=script&lang=js&"
export * from "./custom-row.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports